import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ProviderObjectModel } from '../../buyer';
import { QuickCashData } from '../../services/quick-cash-data.service';
import { SellerNameSaverService } from '../../services/seller-name-saver.service';

@Component({
  selector: 'app-fawry-sucess-buyer',
  templateUrl: './cash-success-buyer.component.html',
  styleUrls: ['./cash-success-buyer.component.scss']
})
export class CashSuccessBuyerComponent implements OnInit {
  message1: string;
  message2: string;
  data: ProviderObjectModel;
  providerRefNum: string = ''

  constructor(
    private quickCashData: QuickCashData,
    private translate: TranslateService,
    private router: Router,
    public SellerNameSaver : SellerNameSaverService
  ) {
    this.translate.use('en');
  }

  async ngOnInit() {
    this.data = this.quickCashData.data;
    if (!this.data) {
      // can't open if it has success data
      this.router.navigate(["/404"]);
    }
    // TODO update this when backend is complete
    this.message1 = this.translate.instant("PROVIDER.CASH.MESSAGE1");
    this.message2 = this.translate.instant("PROVIDER.CASH.MESSAGE2", {
      voucher: this.data.voucher
    });
  }

  onContinueClick(){
    if (this.SellerNameSaver.pattern){
      this.router.navigate(['/', this.SellerNameSaver.pattern])
    } else {
      this.router.navigate(['/']);
    }
  }
}
